import React from "react";
import "./BaseButton.scss";
import { Button } from "@mui/material";

const primaryButtonStyle = {
  border: 'none',
  borderRadius: '3px',
  backgroundColor: '#145388',
  padding: '8px 15px',
  color: '#fff',
  fontFamily: 'Nunito',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '15.4px',
  display: 'flex',
  justifyContent: 'space-evenly',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#1A619C', 
  },
  marginTop: 2
};

const secondaryButtonStyle = {
  border: 'solid',
  borderRadius: '33px',
  backgroundColor: '#fff',
  padding: '8px 15px',
  color: '#145388',
  fontFamily: 'Nunito',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '26.4px',
  display: 'flex',
  justifyContent: 'space-evenly',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#F1F1F1',
  },
}
  
  const addNewButtonStyle = {
    background: "#3BC97B",
    fontFamily: "Inter",
    fontSize: "12px",
    lineHeight: "15.6px",
    color: "#FFF",
    border: "none",
    padding: "6px 31px",
    // height: "30px",
    borderRadius: "30px",
    marginTop: "10px",
    '&:hover': {
      backgroundColor: '#5DD394',
    },
  }

  const saveButtonStyle = {
    backgroundColor: "#008ECC", // Replace with your desired color
    color: "#fff",
    textTransform: "capitalize",
    fontFamily: "Inter",
    "&:hover": {
      backgroundColor: "#0056b3", // Darker shade for hover
    },
    borderRadius: "8px",
    fontSize: "12px",
    '@media (min-width: 1720px)': {
      marginBottom: "30px",
    },
  }

  const tertiaryStyleButton = {
    background: "#f3f4f6",
    fontFamily: "Inter",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#00365A",
    border: "none",
    padding: "4px 20px",
    marginTop: "10px",
    fontWeight: "600",
    marginBottom:"20px",
  }

function BaseButton({ buttonText, onClick, disabled, type = "button", buttonStyle = "button-style", height, sx={} }) {
  const styleMap = {
    'button-style': primaryButtonStyle,
    'secondary-button-style': secondaryButtonStyle,
    'add-new-button': addNewButtonStyle,
    'save-button': saveButtonStyle,
    'tertiary-style': tertiaryStyleButton
  };

  return (
    <Button
      type={type}
      sx={{
        ...(styleMap[buttonStyle] || {}),
        ...(disabled && {
          backgroundColor: "grey",
          cursor: "not-allowed",
          color: '#fff !important',
          textTransform: "none",
          ...(height && { height: {height} }),
        }),
        ...sx
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {buttonText}
    </Button>
  );
}

export default BaseButton;
